import { useMutation } from '@apollo/client'
import { useToast } from '@ur-solutions/react-components'
import { useTranslate } from '@ur-solutions/react-hooks'
import { Select } from 'components/Select'
import { PATCH_COMPANY_MUTATION } from 'modules/companies/mutations'
import {
  PatchCompanyMutation,
  PatchCompanyMutationVariables,
} from 'modules/companies/types.graphql'
import { useInfringementSeverityOptions } from 'modules/infringements/hooks'
import { useCompany, useOnErrorAuto } from 'utils/hooks'

export const ResponsibleUserNotificationThreshold: React.FC = () => {
  const translations = useTranslate({
    success: 'settings.toasts.company-settings-updated',
    error: 'settings.errors.company-settings-generic',
  })

  const company = useCompany()
  const addToast = useToast()
  const onErrorAuto = useOnErrorAuto()

  const [patchCompanyMutation] = useMutation<
    PatchCompanyMutation,
    PatchCompanyMutationVariables
  >(PATCH_COMPANY_MUTATION, {
    refetchQueries: ['Bootstrap', 'Company'],
    onCompleted: () => {
      addToast('success', translations.success)
    },
    onError: onErrorAuto(translations.error),
  })

  const severityOptions = useInfringementSeverityOptions()

  const handleClick = (value: string | null) => {
    patchCompanyMutation({
      variables: {
        id: company.id,
        input: {
          infringementAdminSeverityNotificationThreshold: value,
        },
      },
    })
  }

  return (
    <Select
      value={company.infringementAdminSeverityNotificationThreshold}
      options={severityOptions}
      nullable={false}
      onChange={value => handleClick(value)}
      fullWidth
      grayed
    />
  )
}
